document.addEventListener('variant:change', function(data) {
    const variant = data.detail.variant;
    const preorder = document.querySelector('#add-preorder');
    const button = document.querySelector('#add-button');
    const backInStock = document.querySelector('#back-in-stock-button');

    function getPreorderInput() {
        const input = document.createElement('input');
        input.setAttribute('value', window.Theme.language.preorder);
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'properties[preorder]');
        input.setAttribute('id', 'preorder');
        return input;
    }

    const preorderInput = getPreorderInput();

    if (variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0) {
        preorder.style.display = 'block';
        button.style.display = 'none';
        backInStock.style.display = 'none';
        preorder.append(preorderInput);
    } else if (variant.inventory_policy != 'continue' && variant.inventory_quantity <= 0) {
        preorder.style.display = 'none';
        button.style.display = 'none';
        backInStock.style.display = 'block';
        document.querySelector('#preorder').remove();
    } else {
        preorder.style.display = 'none';
        button.style.display = 'block';
        backInStock.style.display = 'none';
        document.querySelector('#preorder').remove();
    }
})